import { handleRequest } from "../../axios";
import { axiosInstance } from "./JsdhNotifikaceService";
import { NASTENKA_URL, NASTENKA_BY_ID_URL, NASTENKA_PIN_URL, NASTENKA_UNPIN_URL } from "../url";
import type {
    Nastenka,
    NastenkaFeedResponse,
    CreateNastenkaRequest,
    UpdateNastenkaRequest,
} from "../generated/models/Nastenka";

const getFeed = () =>
    handleRequest<NastenkaFeedResponse>(() => axiosInstance.get(NASTENKA_URL));

const createNastenka = (data: CreateNastenkaRequest) =>
    handleRequest<Nastenka>(() => axiosInstance.post(NASTENKA_URL, data));

const updateNastenka = (id: number, data: UpdateNastenkaRequest) =>
    handleRequest<Nastenka>(() => axiosInstance.put(NASTENKA_BY_ID_URL(id), data));

const deleteNastenka = (id: number) =>
    handleRequest(() => axiosInstance.delete(NASTENKA_BY_ID_URL(id)));

const pinNastenka = (id: number) =>
    handleRequest(() => axiosInstance.put(NASTENKA_PIN_URL(id)));

const unpinNastenka = (id: number) =>
    handleRequest(() => axiosInstance.put(NASTENKA_UNPIN_URL(id)));

const NastenkaService = {
    getFeed,
    createNastenka,
    updateNastenka,
    deleteNastenka,
    pinNastenka,
    unpinNastenka,
};
export default NastenkaService;
